document.addEventListener("DOMContentLoaded", function() {
  const modalPage = document.getElementById('modal-page');
  const modalPageCloseBtn = document.getElementById('modal-page-close');
  const modalPageCloseBtn2 = document.getElementById('modal-page-close2');
  const tilesContainer = document.getElementById('tiles-container');
  const modalcontenu = document.getElementById('main-content-custom');

  const modal = document.getElementById('modal-patchwork');
  const modalCloseBtn = document.getElementById('modal-close');
  const fullscreenModal = document.getElementById('modal-fullscreen');
  const fullscreenImage = document.getElementById('modal-fullscreen-image');
  const fullscreenCloseBtn = document.getElementById('modal-fullscreen-close');
  let scrollPosition = 0;

  function adjustBackgroundHeight() {
    const backgroundContainer = document.getElementById('background-container');
    const mainContent = document.getElementById('main-content-custom');
    const modalPage = document.getElementById('modal-page');
    const titleElement = document.querySelector('.titre');
    const subtitleElement = document.querySelector('.sous-titre');

    if (window.innerWidth <= 768) {
      let totalHeight = 0;

      if (!modalPage.classList.contains('hidden')) {
        totalHeight = modalPage.offsetHeight;

        const modalPageTitle = document.getElementById('modal-page-title');
        const modalPageDescription = document.getElementById('modal-page-description');
        const titleHeight = modalPageTitle ? modalPageTitle.offsetHeight : 0;
        const descriptionHeight = modalPageDescription ? modalPageDescription.offsetHeight : 0;

        totalHeight -= (titleHeight + descriptionHeight);
        totalHeight = Math.max(totalHeight - 52, 0);
      } else {
        if (titleElement) {
          totalHeight += titleElement.offsetHeight;
        }
        if (subtitleElement) {
          totalHeight += subtitleElement.offsetHeight;
        }
        if (mainContent) {
          totalHeight += mainContent.offsetHeight;
        }

        totalHeight += 100;
      }

      backgroundContainer.style.height = `${totalHeight}px`;
      backgroundContainer.style.maxHeight = 'none';
    } else {
      backgroundContainer.style.height = '100%';
      backgroundContainer.style.maxHeight = '852px';
    }
  }

  adjustBackgroundHeight();

  window.addEventListener('resize', adjustBackgroundHeight);

  if (modalPageCloseBtn) {
    modalPageCloseBtn.addEventListener('click', () => {
      modalPage.classList.add('hidden');
      modalcontenu.classList.remove('hidden');
      tilesContainer.classList.remove('hidden');
      document.body.style.overflow = '';

      if (window.innerWidth <= 768) {
        setTimeout(adjustBackgroundHeight, 100);
      }
    });
  }
  if (modalPageCloseBtn2) {
    modalPageCloseBtn2.addEventListener('click', () => {
      modalPage.classList.add('hidden');
      modalcontenu.classList.remove('hidden');
      tilesContainer.classList.remove('hidden');
      document.body.style.overflow = '';

      if (window.innerWidth <= 768) {
        setTimeout(adjustBackgroundHeight, 100);
      }
    });
  }

  document.querySelectorAll('[data-modal-info]').forEach(element => {
    element.addEventListener('click', () => {
      setTimeout(() => {
        const images = modalPage.querySelectorAll('img');
        const iframes = modalPage.querySelectorAll('iframe');
        const promises = [];

        images.forEach(img => {
          if (!img.complete) {
            promises.push(new Promise(resolve => {
              img.onload = resolve;
              img.onerror = resolve;
            }));
          }
        });

        iframes.forEach(iframe => {
          promises.push(new Promise(resolve => {
            iframe.onload = resolve;
            iframe.onerror = resolve;
          }));
        });

        Promise.all(promises).then(() => {
          adjustBackgroundHeight();
        });
      }, 100);
    });
  });

  modalPage.addEventListener('click', (event) => {
    if (event.target === modalPage) {
      modalPage.classList.add('hidden');
      modalcontenu.classList.remove('hidden');
      tilesContainer.classList.remove('hidden');
      document.body.style.overflow = '';
    }
  });

  document.querySelectorAll('[data-modal-info]').forEach(element => {
    element.addEventListener('click', () => {
      const tileInfo = JSON.parse(element.getAttribute('data-modal-info'));

      if (window.innerWidth <= 768) {
        const modalPageImage = document.getElementById('modal-page-image');
        if (tileInfo.image) {
          modalPageImage.innerHTML = `<img src="${tileInfo.image}" alt="Image" class="w-full h-auto object-cover">`;
        } else {
          modalPageImage.innerHTML = '';
        }
        const modalTitle = document.getElementById('modal-page-title');
        if (tileInfo.titre) {
          modalTitle.innerHTML = tileInfo.titre;
        } else {
          modalTitle.innerHTML = '';
        }
        const modalDescription = document.getElementById('modal-page-description');
        if (tileInfo.description) {
          modalDescription.innerHTML = tileInfo.description;
        } else {
          modalDescription.innerHTML = '';
        }

        const modalPageIframeTitle = document.getElementById('modal-page-iframe-title');
        if (tileInfo.iframeTitre) {
          modalPageIframeTitle.innerHTML = tileInfo.iframeTitre;
        } else {
          modalPageIframeTitle.innerHTML = '';
        }

        const modalPageIframe = document.getElementById('modal-page-iframe');
        if (tileInfo.iframeLien) {
          modalPageIframe.innerHTML = `<iframe src="${tileInfo.iframeLien}" class="w-full h-[300px] border-0"></iframe>`;
          modalPageIframe.classList.remove('hidden');
        } else {
          modalPageIframe.classList.add('hidden');
        }
        const modalContenu = document.getElementById('main-content-custom');
        modalContenu.classList.add('hidden');

        modalPage.classList.remove('hidden');
        tilesContainer.classList.add('hidden');

        window.scrollTo(0, scrollPosition);
        document.body.style.overflow = 'hidden';
      } else {
        const modalImage = document.getElementById('modal-image');
        if (tileInfo.image) {
          modalImage.innerHTML = `<img src="${tileInfo.image}" alt="Image" class="w-full h-auto object-cover">`;
        } else {
          modalImage.innerHTML = '';
        }

        const modalIframeTitle = document.getElementById('modal-iframe-title');
        if (tileInfo.iframeTitre) {
          modalIframeTitle.innerHTML = tileInfo.iframeTitre;
        } else {
          modalIframeTitle.innerHTML = '';
        }

        const modalIframe = document.getElementById('modal-iframe');
        if (tileInfo.iframeLien) {
          modalIframe.innerHTML = `<iframe src="${tileInfo.iframeLien}" class="w-full h-[70vh] border-0"></iframe>`;
          modalIframe.classList.remove('hidden');
        } else {
          modalIframe.classList.add('hidden');
        }

        const modalTitle = document.getElementById('modal-title');
        if (tileInfo.titre) {
          modalTitle.innerHTML = tileInfo.titre;
        } else {
          modalTitle.innerHTML = '';
        }

        const modalDescription = document.getElementById('modal-description');
        if (tileInfo.description) {
          modalDescription.innerHTML = tileInfo.description;
        } else {
          modalDescription.innerHTML = '';
        }

        modal.classList.remove('hidden');
        tilesContainer.classList.remove('hidden');
      }
    });
  });

  modal.addEventListener('click', (event) => {
    if (event.target === modal) {
      modal.classList.add('hidden');
      tilesContainer.classList.remove('hidden');
    }
  });

  const modalEnlargeImageLink = document.getElementById('modal-enlarge-image');

  if (modalEnlargeImageLink) {
    modalEnlargeImageLink.setAttribute('href', '#');
    modalEnlargeImageLink.addEventListener('click', function(event) {
      event.preventDefault();

      let img;

      if (window.innerWidth <= 768) {
        img = document.querySelector('#modal-page-image img');
      } else {
        img = document.querySelector('#modal-image img');
      }

      if (img) {
        fullscreenImage.innerHTML = `<img src="${img.src}" alt="Image agrandie" class="w-auto h-auto max-w-full max-h-full object-contain">`;
        fullscreenModal.classList.remove('hidden');
      }
    });
  }

  if (modalEnlargeImageLink) {
    modalEnlargeImageLink.setAttribute('href', '#');
    modalEnlargeImageLink.addEventListener('click', function(event) {
      event.preventDefault();

      let img;

      if (window.innerWidth <= 768) {
        img = document.querySelector('#modal-page-image img');
      } else {
        img = document.querySelector('#modal-image img');
      }

      if (img) {
        fullscreenImage.innerHTML = `<img src="${img.src}" alt="Image agrandie" class="max-w-full max-h-full w-auto h-auto object-contain">`;
        fullscreenModal.classList.remove('hidden');
      }
    });
  }

  if (fullscreenCloseBtn) {
    fullscreenCloseBtn.addEventListener('click', function() {
      fullscreenModal.classList.add('hidden');
    });
  }

  fullscreenModal.addEventListener('click', function(event) {
    if (event.target === fullscreenModal) {
      fullscreenModal.classList.add('hidden');
    }
  });

  function lazyLoad() {
    const lazyImages = document.querySelectorAll('img.lazyload');
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const image = entry.target;
            image.src = image.dataset.src;
            image.onload = () => {
              image.classList.remove('lazyload');
            };
            observer.unobserve(image);
          }
        });
      });
      lazyImages.forEach(image => {
        imageObserver.observe(image);
      });
    } else {
      lazyImages.forEach(image => {
        image.src = image.dataset.src;
        image.onload = () => image.classList.remove('lazyload');
      });
    }
  }
});
